import { render, staticRenderFns } from "./DefaultEditTabList.vue?vue&type=template&id=2ed8d95c"
import script from "./DefaultEditTabList.vue?vue&type=script&lang=ts"
export * from "./DefaultEditTabList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ed8d95c')) {
      api.createRecord('2ed8d95c', component.options)
    } else {
      api.reload('2ed8d95c', component.options)
    }
    module.hot.accept("./DefaultEditTabList.vue?vue&type=template&id=2ed8d95c", function () {
      api.rerender('2ed8d95c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/view-editor/DefaultEditTabList.vue"
export default component.exports